const isOverSize = (files, maxSize) =>
  files.reduce((acc, { size }) => acc + size, 0) > maxSize;

export default isOverSize;
